import { Component, Input } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-tooltip',
  standalone: false,
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss'
})
export class TooltipComponent {

  @Input() tituloTooltip: string | undefined = undefined;
  @Input() exibeTooltip: boolean = true;

  public mouseEnter(trigger: MatMenuTrigger): void {
    if (this.exibeTooltip)
      trigger.openMenu();
  }
}
